module.exports = __webpack_public_path__ + "img/heart.6d61005c.svg";